import { Checkbox, FormControlLabel, styled, Typography, Stack } from '@mui/material';
import PropTypes from 'prop-types';

const StyledCheckBox = styled(Checkbox)({
    '& .MuiSvgIcon-root': {
        fontSize: 22.28,
    },
    width: 40.28,
    height: 40.28,
});

function RpCheckbox(props) {
    // https://corelogic.atlassian.net/browse/RPSUITE-180648922?focusedCommentId=18178693
    const adjustFontSize = props.label && props.label.length > 50;
    const fontSize = adjustFontSize ? { fontSize:'12px' } : {};
    const marginTop = adjustFontSize ? '8px' : '10px';
    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <FormControlLabel
                sx={{ alignItems: 'flex-start' }}
                control={
                    <StyledCheckBox
                        checked={props.checked}
                        onChange={props.onChange}
                        color="tertiary"
                    />
                }
                label={
                    <Typography variant="text1" sx={{ marginTop, ...fontSize }}>
                        {props.label}
                    </Typography>
                }
            />
            {
                props.icon
            }
        </Stack>

    );
}

RpCheckbox.propTypes = {
    value: PropTypes.bool,
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    icon: PropTypes.node,
};

export default RpCheckbox;